import LegalLayout, { Section } from "./LegalLayout";

export default function Rodo() {
  return (
    <LegalLayout title="Informacja RODO" lastUpdated="28 maja 2026">
      <p className="text-base">
        Zgodnie z rozporządzeniem Parlamentu Europejskiego i Rady (UE) 2016/679 z dnia 27 kwietnia 2016 r.
        w sprawie ochrony osób fizycznych w związku z przetwarzaniem danych osobowych i w sprawie swobodnego
        przepływu takich danych (RODO), informujemy o zasadach przetwarzania Twoich danych osobowych.
      </p>

      <Section title="Kto jest administratorem Twoich danych?">
        <p>
          Administratorem danych osobowych jest <strong>Telecom BTS sp. z o.o.</strong>
          z siedzibą w Warszawie (ul. Adama Mickiewicza 55, 01-625 Warszawa), wpisana do rejestru przedsiębiorców
          KRS pod numerem 0000872371, NIP 525-28-44-929, REGON 387672774.
        </p>
        <p>
          Kontakt:
          <a href="mailto:biuro@telecombts.pl" className="text-emerald-700 hover:underline ml-1">biuro@telecombts.pl</a>,
          tel. <a href="tel:+48512929641" className="text-emerald-700 hover:underline">+48 512 929 641</a>.
        </p>
      </Section>

      <Section title="W jakim celu i na jakiej podstawie przetwarzamy Twoje dane?">
        <p>Twoje dane osobowe przetwarzamy na podstawie:</p>
        <ul className="list-disc list-inside space-y-1 ml-2">
          <li>
            <strong>Art. 6 ust. 1 lit. a RODO</strong> — udzielonej przez Ciebie zgody w celu kontaktu zwrotnego
            i przedstawienia oferty dzierżawy nieruchomości.
          </li>
          <li>
            <strong>Art. 6 ust. 1 lit. b RODO</strong> — w celu podjęcia działań na Twoje żądanie przed zawarciem
            ewentualnej umowy dzierżawy.
          </li>
          <li>
            <strong>Art. 6 ust. 1 lit. c RODO</strong> — w celu wypełnienia obowiązków prawnych ciążących na
            administratorze (księgowe, podatkowe — jeśli dojdzie do zawarcia umowy).
          </li>
          <li>
            <strong>Art. 6 ust. 1 lit. f RODO</strong> — na podstawie naszego prawnie uzasadnionego interesu
            w celu prowadzenia korespondencji, archiwizacji oraz dochodzenia ewentualnych roszczeń.
          </li>
        </ul>
      </Section>

      <Section title="Jak długo przechowujemy Twoje dane?">
        <ul className="list-disc list-inside space-y-1 ml-2">
          <li>dane z formularza kontaktowego — przez okres do 24 miesięcy od ostatniego kontaktu,</li>
          <li>dane wymagane przepisami podatkowymi i księgowymi — przez okres wymagany prawem (zwykle 5 lat od końca roku rozliczeniowego),</li>
          <li>dane potrzebne do dochodzenia roszczeń — przez okres przedawnienia tych roszczeń.</li>
        </ul>
      </Section>

      <Section title="Komu udostępniamy Twoje dane?">
        <p>Odbiorcami danych osobowych mogą być:</p>
        <ul className="list-disc list-inside space-y-1 ml-2">
          <li>podmioty świadczące dla nas usługi IT i hostingowe (na podstawie umowy powierzenia),</li>
          <li>kancelarie prawne i biura księgowe obsługujące administratora,</li>
          <li>podwykonawcy realizujący ekspertyzy lub audyty techniczne lokalizacji,</li>
          <li>organy publiczne i sądy — wyłącznie w przypadkach przewidzianych prawem.</li>
        </ul>
        <p>Twoje dane nie są profilowane w sposób wywołujący skutki prawne ani nie są przekazywane do państw trzecich poza EOG.</p>
      </Section>

      <Section title="Twoje prawa">
        <p>W każdym czasie przysługuje Ci prawo do:</p>
        <ul className="list-disc list-inside space-y-1 ml-2">
          <li>dostępu do swoich danych (art. 15 RODO),</li>
          <li>sprostowania danych (art. 16 RODO),</li>
          <li>usunięcia danych (art. 17 RODO),</li>
          <li>ograniczenia przetwarzania (art. 18 RODO),</li>
          <li>przenoszenia danych (art. 20 RODO),</li>
          <li>sprzeciwu wobec przetwarzania (art. 21 RODO),</li>
          <li>cofnięcia zgody (art. 7 ust. 3 RODO) — bez wpływu na zgodność z prawem przetwarzania, którego dokonano przed cofnięciem,</li>
          <li>wniesienia skargi do Prezesa Urzędu Ochrony Danych Osobowych (ul. Stawki 2, 00-193 Warszawa).</li>
        </ul>
        <p>
          Aby zrealizować dowolne z powyższych praw, skontaktuj się z nami pod adresem
          <a href="mailto:biuro@telecombts.pl" className="text-emerald-700 hover:underline ml-1">biuro@telecombts.pl</a>.
          Odpowiedź otrzymasz w terminie do 30 dni.
        </p>
      </Section>

      <Section title="Czy podanie danych jest obowiązkowe?">
        <p>
          Podanie danych osobowych w formularzu jest dobrowolne, jednak niezbędne do skontaktowania się
          z Tobą i przygotowania oferty dzierżawy. Brak podania danych uniemożliwia realizację usługi
          kontaktu zwrotnego.
        </p>
      </Section>
    </LegalLayout>
  );
}
